import { User } from '@mode/algolia/contract';
import { SearchEmailPayload } from '@mode/shared/schedules/contract';
import { createAction, props } from '@ngrx/store';

export const searchEmail = createAction('[Email Search] Search Email', props<SearchEmailPayload>());

export const searchEmailSuccess = createAction(
  '[Email Search] Search Email Success',
  props<{ searchResults: User[] }>()
);

export const searchEmailFailure = createAction('[Email Search] Search Email Failure', props<{ error: string }>());
